module.exports = __webpack_public_path__ + "media/images/wave4-e66513ca392f246fb28bad098be327dc.png";